export const GET_PAYMENT_INFO = "GET_PAYMENT_INFO";

export const GET_PAYMENT_INFO_FAILED = "GET_PAYMENT_INFO_FAILED";
export const GET_PAYMENT_INFO_START = "GET_PAYMENT_INFO_START";
